// API Client
import { TransportInventoryType } from "@/dataProviders/TransportInventory";
import { get } from "../CarbonClient";

// API Path
const path = "api/transport/";

// Get transport inventory
// revisionId: pins the inventory — the material weights and their emissions — to a revision's
// saved state (as-of read). Absent = the working state. Axios drops undefined params, so the
// wire is unchanged when not previewing.
// models: the toolbar's global Models selection (RTLCA-5614). The endpoint's parameter is `model`
// (singular) bound as a repeated list, so `indexes: true` serialises it as `model[0]=…&model[1]=…`
// — the same wire contract as `getSpeckleMaterials`. Absent = every model.
async function getTransportInventory(id: string, revisionId?: string, models?: string[]) {
  return get<{ items: TransportInventoryType }>(`${path}${id}`, {
    params: { revisionId, model: models },
    paramsSerializer: { indexes: true },
  });
}

export { getTransportInventory };
